import Vue from 'vue';
import Exposure from './exposure';
const exposure = new Exposure();

Vue.directive('addExposurePoint', {
  inserted: function(el) {
    exposure.add(el);
  }
});



// WEBPACK FOOTER //
// ./src/directive/addExposurePoint/index.js